import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import mgmService from '../../../services/mgmService';

const WelcomeComponent = ({
  setScreenNumber,
  onQuestionClick,
  onChangePointClick,
  onCertificatesClick
}) => {
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    (async () => {
      const balanceData = await mgmService.getBalance();
      setBalance(balanceData?.balance || 0);
    })();
  }, []);

  return (
    <div className={styles.container}>
      <img
        src={getImageFromS3('/images/mgm/bg.png')}
        alt="background"
        className={styles.backgroundImage}
      />
      <div className={styles.content}>
        <div className={styles.headContainer} onClick={onQuestionClick}>
          Є питання?
          <svg
            width="27"
            height="21"
            viewBox="0 0 27 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.86207 0C0.837931 0 0 0.821739 0 1.82609V16.4348L2.7931 13.6957H20.4828C21.5069 13.6957 22.3448 12.8739 22.3448 11.8696V1.82609C22.3448 0.821739 21.5069 0 20.4828 0H1.86207ZM23.2759 7.30435V11.8696C23.2759 13.4217 22.0655 14.6087 20.4828 14.6087H13.0345V16.4348C13.0345 17.4391 13.8724 18.2609 14.8966 18.2609H24.2069L27 21V9.13043C27 8.12609 26.1621 7.30435 25.1379 7.30435H23.2759Z"
              fill="white"
            />
          </svg>
        </div>
        <img
          className={styles.glassHeadBg}
          src={getImageFromS3('/images/mgm/glass-head-bg.png')}
          alt="glass-head"
        />
        <h1>Особистий кабінет</h1>
        <h2>
          <svg
            width="14"
            height="18"
            viewBox="0 0 14 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="3" y="7" width="8" height="9" fill="#DF0E0E" />
            <path
              d="M14 12.2989C14 15.639 11.2594 18 7.39623 18C3.01298 18 0 15.1783 0 10.5384C0 3.29889 6.37266 0 11.02 0C11.7547 0 12.1179 0.361957 12.1179 0.781514C12.1179 1.11883 11.9363 1.39851 11.6639 1.78518C11.0035 2.69011 9.8809 4.00638 9.8809 5.65997C9.8809 5.79981 9.88914 5.93969 9.90566 6.08774C10.3679 5.22395 11.1851 4.61517 12.1757 4.61517C12.4564 4.61517 12.6049 4.77972 12.6049 5.01826C12.6049 5.30623 12.5389 5.51188 12.5389 6.4086C12.5389 8.12796 14 9.28793 14 12.2989ZM7.23111 15.6883C8.88206 15.6883 9.97994 14.6929 9.97994 13.2121C9.97994 11.6572 8.87382 11.106 8.72522 10.1024C8.71698 10.0201 8.65918 9.99542 8.60142 10.053C8.18868 10.4068 7.93277 10.851 7.73466 11.3611C7.69341 11.4516 7.62738 11.4598 7.58606 11.3858C7.13208 10.596 7.04952 9.41956 7.15683 7.93877C7.17335 7.85649 7.11556 7.81536 7.04128 7.84825C5.08491 8.73675 4.0861 10.67 4.0861 12.4058C4.0861 14.1499 5.11791 15.6883 7.23111 15.6883Z"
              fill="url(#paint0_linear_540_6007)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_540_6007"
                x1="11.6667"
                y1="4.18966"
                x2="3.44979"
                y2="16.1569"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFD042" />
                <stop offset="1" stopColor="#FF7F2A" />
              </linearGradient>
            </defs>
          </svg>
          Баланс балів
        </h2>
        <h3>{balance}</h3>
        <button
          className={styles.changePointsButton}
          onClick={onChangePointClick}
        >
          Обміняти бали
        </button>
        <p className={styles.certificates} onClick={onCertificatesClick}>
          Мої <span>сертифікати</span>
        </p>
        <div className={styles.greenButton} onClick={() => setScreenNumber(6)}>
          <img
            src={getImageFromS3('/images/mgm/green-button.png')}
            alt="green"
          />
          <p>Згенерувати код</p>
        </div>
        <div className={styles.purpleButton} onClick={() => setScreenNumber(3)}>
          <img
            src={getImageFromS3('/images/mgm/purple-button.png')}
            alt="purple"
          />
          <p>Історія балів</p>
        </div>
        <div className={styles.footer}>
          <button onClick={() => setScreenNumber(2)}>Правила програм</button>
          <button
            onClick={() =>
              window.open(
                'https://www.pmiprivacy.com/ukraine/uk/consumer/',
                '_blank'
              )
            }
          >
            Політика конфіденційності
          </button>
          <button onClick={() => setScreenNumber(10)}>FAQ</button>
          <button onClick={() => setScreenNumber(11)}>
            Параметри застосування файлів cookie
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeComponent;
